export default "__VITE_ASSET__DmWbKN8g__"